import {resources} from "../../../../../../../core/models/resource/resources";
import { EntityFileType } from "../../../../../../../core/types/file.types";

export const listingFilesResourceType = resources['listing-files'];
export const richContentFilesResourceType = resources['rich-content-files'];

export const modalPath: Record<string, string> = {
  listings: listingFilesResourceType.path,
  richContent: richContentFilesResourceType.path
};

export const titleModal: Record<string, string> = {
  listings: listingFilesResourceType.name,
  richContent: richContentFilesResourceType.name
};

export const listingEntityFileType: Record<string, EntityFileType> = {
  listings: 'LISTING',
  richContent: 'RICH_CONTENT'
}

export const listingKeyParams: Record<string, string> = {
  listings: 'listingId',
  richContent: 'richContentId'
}
